import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "./assets/app.scss";
import axios from "axios";

Vue.use(axios);

//scroll to
const VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);

Vue.component("Form", require("./components/Form.vue").default);
Vue.component("Footer", require("./components/Footer.vue").default);
Vue.component("Loader", require("./components/Loader.vue").default);
Vue.component("Language", require("./components/Language.vue").default);
Vue.component("Scroller", require("./components/Scroller.vue").default);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
